import { useRequestGetVerificationBio, useRequestVerifyBio } from '@/hooks/httpRequest';
import BioVerificationItem from './BioVerificationItem';
import Loader from '@/components/custom/Loader.tsx';
import { notifyInternalMessage } from '@/functions';
import { IBioVerification } from '@/lib/interface';
import { PanelInfo } from '@/components/custom';
import { useEffect, useState } from 'react';
import { PartyPopper } from 'lucide-react';
import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';

interface IState {
	verifiedVerificationIds: string[];
	verifications: IBioVerification[];
}

const CONSTS = {
	initState: {
		verifiedVerificationIds: [],
		verifications: []
	} as IState
};

const BodyPage = () => {

	const { verifications, isLoadingVerifications, verificationsUpdatedAt } = useRequestGetVerificationBio({ config: { staleTime: 0 } });
	const { triggerVerification, invalidateRelatedQueries } = useRequestVerifyBio({ disableInvalidateQueries: true });
	const [state, setState] = useState<IState>(CONSTS.initState);

	useEffect(
		() => setState(() => ({ ...CONSTS.initState, verifications })),
		[verificationsUpdatedAt]
	);

	const handleOnVerify = (verificationId: string, accept: boolean) => {
		// Update state
		const newState = ({
			...state,
			verifications: [...state.verifications].filter(item => item._id !== verificationId),
			verifiedVerificationIds: [...state.verifiedVerificationIds, verificationId]
		});
		// Remove verification from list
		setState(newState);
		// Scroll to first element
		window.scroll({ left: 0, top: 0, behavior: 'smooth' });
		// Sync with server
		triggerVerification({ verificationId, accept })
			.then(
				() => {
					newState.verifiedVerificationIds.length !== 0 &&
						newState.verifications.length == 0 &&
						invalidateRelatedQueries();
				}
			)
			.catch(notifyInternalMessage);
	};

	if (isLoadingVerifications) {
		return (
			<div className='my-10'>
				<Loader className='my-10' />
			</div>
		);
	}

	if (state.verifications.length === 0) {
		return (
			<PanelInfo
				title='Terminé!'
				description={`Vous n'avez actuellement aucune vérification disponible`}
				className='py-10 md:py-28 border-none'
				iconClassName='text-green-500'
				icon={PartyPopper}>
				<Button
					onClick={invalidateRelatedQueries}
					variant={'secondary'}
					type='button'>
					Actualiser la page
				</Button>
			</PanelInfo>
		);
	}

	return (
		<div className={cn(
			'grid grid-cols-1 gap-3',
			'sm:grid-cols-2',
			'md:grid-cols-3',
			'xl:grid-cols-4',
		)}>
			{
				state
					.verifications
					.map(
						item => (
							<div
								key={item._id}
								className='flex items-start'>
								<BioVerificationItem
									onVerify={handleOnVerify}
									item={item} />
							</div>
						)
					)
			}
		</div>
	);

};

export default BodyPage;

